import React from 'react';
import { unmountComponentAtNode, findDOMNode } from 'react-dom';
import classNames from 'classnames';

export default class Notification extends React.Component {
  state = {
    hiding: false
  };

  onClick = (e) => {
    e.preventDefault();
    this.hide();
  };

  hide = () => {
    this.setState({ hiding: true });

    setTimeout(() => {
      // eslint-disable-next-line react/no-find-dom-node
      const thisNode = findDOMNode(this); // if not unmounted
      if (thisNode) {
        unmountComponentAtNode(thisNode.parentNode);
      }
    }, 250);
  };

  componentDidMount() {
    setTimeout(this.hide, 3000);
  }

  render() {
    const { initProps: { text, status } } = this.props;
    const { hiding } = this.state;

    const className = classNames('notification', {
      [`notification--${status}`]: true,
      'notification--hiding': hiding
    });

    return (
      <div className={className} onClick={this.onClick}>
        <div className="notification__text">
          {text}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/Assets/js/features/notification/index.js